import { useParams } from '@tanstack/react-router';
import { InterviewTypeDetailContainer } from '../../contexts/interview-types';

export function InterviewTypeDetailPage() {
  const { interviewTypeId } = useParams({
    from: '/authenticated/orgs/$orgSlug/templates/$interviewTypeId/',
  });

  return <InterviewTypeDetailContainer interviewTypeId={interviewTypeId} />;
}
